import { useMutation } from 'react-query';

import { extractBattleCardToXls as mutationFn } from 'api/endPoints/extractBattleCardToXls';

export const useMutationRowsBoardToXls = () => {
    return useMutation<unknown, QueryError, IUseMutationRowsBoardToXlsPayload>((params) => mutationFn(params));
};

interface IUseMutationRowsBoardToXlsPayload {
    fileName: string;
    filter: any;
    configRequest: {
        contractId: number;
        isExtractRemainingDuration: boolean;
        isExtractPercentageComplete: boolean;
        userData: string;
    };
}
